import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Contact } from "../../../../../auth/models";
import { Supplier, Tender } from '../../../../models';
import { TenderSupplierInvitationInfoService } from '../../../../services';

@Component({
    selector: 'jft-invitation-info-modal',
    templateUrl: './invitation-info-modal.component.html',
    styleUrls: ['./invitation-info-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvitationInfoModalComponent implements OnInit {
    public loading: boolean = false;
    public invitationHtml = null;


    constructor(
        private tender: Tender,
        private supplier: Supplier,
        private contact: Contact,
        private activeModal: NgbActiveModal,
        private route: ActivatedRoute,
        private invitationService: TenderSupplierInvitationInfoService,
    ) {
    }

    public ngOnInit() {
        this.getInvitationInfo()
    }

    public getInvitationInfo() {
        this.invitationService.fetch(this.tender.id, this.supplier.id, this.contact.id).subscribe(
            (data: any) => {
                this.invitationHtml = data.data;
            }
        )
    }

    public copy(event: string): void {
    }

    public close() {
        this.activeModal.dismiss();
    }
}
